import { Component, OnInit, inject } from '@angular/core';
import { CommonService } from '../../common.service';

@Component({
  selector: 'app-returns',
  templateUrl: './returns.html',
  styleUrl: './returns.scss',
})
export class Returns implements OnInit {
  private readonly commonService = inject(CommonService);

  ngOnInit(): void {
    this.commonService.showTitle('/assets/titles/returns.jpg');
  }
}
